module.exports = __webpack_public_path__ + "img/platon-combine.1dbbe078.png";